export default __webpack_public_path__ + "static/media/blog-level-4.75cb6683.svg";